<style>
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
a {
  color: #333333;
  text-decoration: none;
}
a:hover {
  color: #1890ff;
  text-decoration: none;
}
.hdNews {
  padding: 12px 24px;
  margin-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.content_body li {
  line-height: 28px;
  padding: 0 0 0 10px;
}
.clear {
  clear: both;
}
</style>
<template>
  <div>
    <HeaderView></HeaderView>
    <NavigateView></NavigateView>
    <BannerView></BannerView>
    <div v-bind:style="{minHeight: height+'px'}" style="width: 980px; margin: 0 auto;">
      <template>
        <div class="content_body">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item style="padding-top: 8px;">企业申报</el-breadcrumb-item>
            <el-breadcrumb-item style="padding-top: 8px;">综合评价公示</el-breadcrumb-item>
          </el-breadcrumb>
          <el-divider content-position="left"></el-divider>
          <!-- <el-form key="product" :model="product" ref="product" label-width="300px">
            <el-collapse v-model="activeName">
              <el-collapse-item v-for="(outer, key) in xnItems" v-if="outer.name" :key="key" :disabled="outer.disabled">
                <template #title>
                  <h4 style="width: 180px; text-align: right;">{{outer.name}}（{{outer.score}}分）</h4>
                  <el-alert v-if="outer.info" :title="outer.info" type="info" show-icon :closable="false"></el-alert>
                </template>
              </el-collapse-item>
            </el-collapse>
          </el-form> -->
          <div class="lvtables">
            <el-table :data="tableData" style="width: 100%" ref="isExpand" max-height="860">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table ref="multipleTable" :data="props.row.declareList" style="width: 100%; margin-left: 0" max-height="360" size="mini"
                    :row-style="rowStyle" :header-cell-style="rowStyle" :cell-style="rowStyle">
                    <el-table-column prop="product.drugName" label="通用名" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
                    <el-table-column prop="product.drugDosage" label="剂型" width="100" align='center' :show-overflow-tooltip='true'></el-table-column>
                    <el-table-column prop="product.packageSpecific" label="包装规格" width="130" align='center' :show-overflow-tooltip='true'></el-table-column>
                    <el-table-column prop="product.producerName" label="生产企业" width="160" align='center' :show-overflow-tooltip='true'></el-table-column>
                    <el-table-column prop="product.code" label="药品统一编码" width="165" align='center'></el-table-column>
                    <el-table-column prop="score" label="综合评价分" width="65" align='right'>
                      <template #default="scope">
                        {{ ((Number(scope.row.score) / 2 * 100)>>0) / 100 }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="statusDesc" label="星级" width="70" align='center'></el-table-column>
                    <el-table-column label="操作" width="100" align='center'>
                      <template #default="scope">
                        <!-- <el-button @click="operate = true; handleClick(scope.row, scope.row.fn)" type="text" size="small">{{scope.row.operate}}</el-button> -->
                        <el-button @click="showQtyScore(scope.row)" type="text" size="small">查看</el-button>
                        <template v-if="!scope.row.myself">
                          <el-button v-if="!scope.row.status" @click="operate = false; question(scope.row)" type="text" size="small">质疑</el-button>
                          <el-button v-if="scope.row.status" @click="operate = false; question(scope.row)" type="text" size="small">已质疑</el-button>
                        </template>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column prop="declareNum" label="本组申报厂家" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
              <el-table-column prop="largeTypeName" label="药品大类" width="150" align='center'></el-table-column>
              <el-table-column prop="categoryName" label="药品名称" width="200" align='center'></el-table-column>
              <el-table-column prop="dosageCategoryName" label="大剂型" width="200" align='center' :show-overflow-tooltip='true'></el-table-column>
              <!-- <el-table-column prop="status" label="状态" width="110" align='center'>
                <template #default="scope">
                  <el-tag v-if="scope.row.tag"
                    :type="scope.row.tag === '已保存' ? 'info' : (scope.row.tag === '已报名' ? 'primary' : (scope.row.tag === '审核通过' ? 'success' : (scope.row.tag === '审核未通过' ? 'danger' : ''))) "
                      disable-transitions>{{scope.row.tag}}</el-tag>
                </template>
              </el-table-column> -->
              <el-table-column label="操作" align='center'>
                <template #default="scope">
                  <el-button v-if="!scope.row.status" @click="operate = true; moveOut(scope.row)" type="text" size="mini"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </template>
    </div>
    <!-- 生产企业药品药品综合评价（西药 -> 自评） -->
    <el-dialog :title="product.drugInfo" :visible.sync="dialogFormVisible" width="1280px" top="0px" marginTop="5px" marginButton="5px" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
      <el-form key="product" :model="product" ref="product" label-width="200px" disabled>
        <el-collapse v-model="activeName">
          <el-collapse-item v-for="(outer, key) in xnItems" v-if="outer.name" :key="key" :disabled="outer.disabled" :name="key">
            <template #title>
              <h4 style="width: 220px; text-align: right;">
                {{outer.name}}（{{outer.score}}分）
                <template v-if="outer.val">
                  <el-badge type="primary" :value="outer.val" v-if="outer.val" :max="200" class="sub-assess-score"></el-badge>
                </template>
                <template v-else>
                  <div class="el-badge sub-assess-score" style="width: 27px;"></div>
                </template>
              </h4>
              &emsp;&emsp;
              <template v-for="inner in outer.subItems">
                <template v-if="selectedMap.get(`${key}${inner.index}`)">
                  <el-badge type="success" :value="selectedMap.get(`${key}${inner.index}`)" :max="200" class="assess-score">
                    <el-tag effect="plain">{{inner.name}}</el-tag>
                  </el-badge>
                </template>
                <template v-else>
                  <el-tag type="info" effect="plain">{{inner.name}}</el-tag>
                </template>
              </template>
            </template>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <template #footer>
        <span>
            <el-button size="mini" @click="dialogFormVisible = false">关&emsp;闭</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- DRS星级质疑 需要上传凭证（图片） -->
    <el-dialog title="联盟药品综合评价「质疑」" :visible.sync="dialogVisible" width="40%" top="200px">
      <el-alert title="填写提示" type="info" show-icon :closable="false">
        <div style="color: #FF5722; line-height: 22px; font-weight: 500; font-size: 13px;">
        &emsp;1、请明确表明要质疑的得分项（通过“操作”列的“查看”功能进行截图标记）；</br>
        &emsp;2、请依次对质疑的得分项进行说明并添加资质证明材料；</br>
        &emsp;3、请将质疑材料整理到一份PDF文档中，并加盖申诉人公章（如无则不予受理）；</br>
        &emsp;4、请上传质疑材料（PDF格式）并进行“确认”。</div>
      </el-alert>
      <div>&emsp;</div>
      <el-form key="product" :model="product" :rules="productRules" ref="product">
        <el-form-item label="药品信息" :label-width="labelWidth100">
          <el-input v-model="product.drugInfo" autocomplete="off" readonly style="width: 95%"></el-input>
        </el-form-item>
        <el-form-item label="药品统一编码" :label-width="labelWidth100">
          <el-input v-model="product.code" autocomplete="off" readonly style="width: 95%"></el-input>
        </el-form-item>
        <el-form-item label="星级" :label-width="labelWidth100">
          <el-input v-model="product.statusDesc" autocomplete="off" readonly style="width: 95%"></el-input>
        </el-form-item>
        <el-form-item label="综合评价分" :label-width="labelWidth100">
          <el-input v-model="product.score" autocomplete="off" readonly style="width: 95%"></el-input>
        </el-form-item>
        <el-form-item label="质疑凭据" :label-width="labelWidth100" prop="credential">
          <el-upload
            class="upload-left"
            :action="uploadImgUrl"
            :on-preview="handlePreview"
            :before-remove="beforeRemove"
            :on-remove="handleRemoveCredential"
            :multiple="false"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeFileUpload"
            :on-success="handleSuccessCredential"
            :on-error="handleError"
            :file-list="fileListCredential"
            >
            <el-button :loading="submitButtonLoading" size="small" type="primary">上传质疑凭据（仅支持pdf格式）</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <template #footer v-if="!product.status">
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取&emsp;消</el-button>
          <el-button :loading="submitButtonLoading" type="primary" icon="el-icon-circle-check" @click="submitQuestion('product')">确&ensp;认</el-button>
        </span>
      </template>
    </el-dialog>
    <FooterView></FooterView>
  </div>

</template>
<script>
export default {
  name: 'concernedAbout',
  data () {
    return {
      active: 0,
      height: 0,
      operate: false,
      captchaUrl: '',
      activeName: '',
      dialogVisible: false,
      dialogFormVisible: false,
      submitButtonLoading: false,
      xnItems: {
        'xn11': { id: '', val: 0, name: '药品可及性', info: '同一产品按就高原则取一项得分', score: 40, disabled: false,
          subItems: [{type: 'el-radio-group', name: '基本药物目录（20分）', index: 1}, {type: 'el-radio-group', name: '医保目录（20分）', index: 2}],
          remark: '无补充说明！'},
        'xn12': { id: '', val: 0, name: '技术含量', info: '同一产品按就高原则取一项得分', score: 30, disabled: false,
          subItems: [{type: 'el-radio-group', name: '基础分（25分）', index: 1}, {type: 'el-radio-group', name: '附加分（5分）', index: 2}],
          remark: ''},
        'xn13': { id: '', val: 0, name: '临床适用性', info: '同一产品按就高原则取一项得分', score: 20, disabled: false,
          subItems: [{type: 'el-radio-group', name: '有效性（6分）', index: 1},
          {type: 'el-checkbox-group', name: '安全性（6分）', index: 2, remark: '安全性评价可多选，按勾选累计得分'},
          {type: 'el-radio-group', name: '经济性（8分）', index: 3}],
          remark: ''},
        'xn14': { id: '', val: 0, name: '产品市场占有情况', info: '同一产品按就高原则取一项得分', score: 10, disabled: false,
          subItems: [{type: 'el-radio-group', name: '执行中的其他省级招标中标情况（3分）', index: 1}, {type: 'el-radio-group', name: '上一年度品种产量（4分）', index: 2}, {type: 'el-radio-group', name: '同品种全国市场占有率（3分）', index: 3}],
          remark: '无补充说明！'},
        'xn15': { id: '', val: 0, name: '企业质量管理水平', info: '同一产品按就高原则取一项得分', score: 35, disabled: false,
          subItems: [{type: 'el-radio-group', name: '基础分（30分）', index: 1}, {type: 'el-radio-group', name: '附加分（5分）', index: 2}],
          remark: '无补充说明！'},
        'xn16': { id: '', val: 0, name: '企业药品保障供应能力', info: '同一产品按就高原则取一项得分', score: 30, disabled: false,
          subItems: [{type: 'el-radio-group', name: '行业排名（15分）', index: 1,
          remark: '1、外资企业<br> 1.1、纳入美国《制药经理人》（Pharmaceutical Executive）上一年度排名前50强在大陆的独资或控股企业。（15分）<br//>1.2、未收录或排名超出50位（5分）<br/>2、内资企业<br/>	按最新出版《中国医药统计年报》中医药工业企业法人单位主营业务排名分5档计分。 <br/>2.1、前50强（15分）<br/>2.2、前100强（12分）<br/>2.3、前150强（8分）<br/>2.4、前200（4分）<br/>	2.5、未收录或排名超出200位（2分）'
          },
          {type: 'el-radio-group', name: '本市药品配送到位情况（15分）', index: 2}],
          remark: '无补充说明！'},
        'xn17': { id: '', val: 0, name: '企业创新能力', info: '同一产品按就高原则取一项得分', score: 20, disabled: false,
          subItems: [{type: 'el-radio-group', name: '技术奖获奖情况（5分）', index: 1, remark: '1、外资企业<br/>&emsp;近3年内获Prix Galien奖（限英、法、德、美4国，每项1分，可累计，最高5分）<br/>2、内资企业<br/>&emsp;近3年内获国家级科学技术奖（二等及以上）（每项1分，可累计，最高5分）'},
          {type: 'el-radio-group', name: '省级以上企业技术中心(创新平台)认定情况（5分）', index: 2}, {type: 'el-radio-group', name: '上一年度新药注册申请量（5分）', index: 3}, {type: 'el-radio-group', name: '承担国家重大新药创制科技重大专项课题（5分）', index: 4}],
          remark: '无补充说明！'},
        'xn18': { id: '', val: 0, name: '企业社会责任承担', info: '同一产品按就高原则取一项得分', score: 15, disabled: false,
          subItems: [{type: 'el-checkbox-group', name: '多选项（15分）', index: 1, remark: '可多选，按勾选累计得分', repel: 'xn182'},
          {type: 'el-radio-group', name: '单选项（2分）', index: 2, repel: 'xn181'}],
          remark: '无补充说明！'},
        'xn19': { id: '', val: 0, name: '企业信誉度', info: '满足任意一项即扣分，最多扣减40分', score: -40, disabled: false,
          subItems: [{type: 'el-radio-group', name: '药品质量抽验通报', index: 1},
                    {type: 'el-radio-group', name: '其他不良记录', index: 2}],
          remark: '无补充说明！'},
        'XN': { id: '', val: 0, score: 0, disabled: false},
      },
      product: {
        id: '', delcareId: '', drugInfo: '', code: '', score: 0, blackRecord: '', blackMark: '', remark: '', stype: '', credential: '', status: 0,
        xn111: '', xn112: '', xn121: '',  xn122: '',
        xn131: '', xn132: [], xn133: '',
        xn141: '', xn142: '', xn143: '',
        xn151: '', xn152: '', xn161: '', xn162: '',
        xn171: '', xn172: '', xn173: '', xn174: '',
        xn181: [], xn182: '', xn191: '', xn192: '',
      },
      productRules: {
        credential: [
          { required: true, message: '请上传质疑凭据材料！', trigger: 'blur' },
        ],
      },
      labelWidth100: '120px',
      tableData: [],
      configList: [],
      xnConfigMap: new Map(),
      requiredMap: new Map(),
      selectedMap: new Map(),
      queryform: {
        data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50, 100], fn: 'page',
      },
      fileListCredential: [],
      categoryList: [],
      uploadImgUrl: process.env.VUE_APP_API_URL + 'member/o_upload_image2.jspx',
      liBackgroundImg: process.env.VUE_APP_API_URL + 'r/cms/www/default/img/index/li_bg.jpg',
    };
  },
  mounted () {
    // sessionStorage['/concerned'] = true;
    if(!sessionStorage[this.$route.path]){
        window.location.href = process.env.VUE_APP_API_URL;
      }
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.height = document.documentElement.clientHeight - 350;
    //监听浏览器窗口变化　
    window.onresize = () => { this.height = document.documentElement.clientHeight - 350 }
  },
  created () {
    this.initView()
  },
  watch: {},
  methods: {
    initView () {
      setTimeout(() => {
        const self = this
        self.submitButtonLoading = true;
        //报名规则
        self.declareGroupList({ }).then(res => {
          self.handleDeclareGroupList(res)
          return self.getBusinessConfig({ stype: 'XN' });
        }).then(res => {
          self.handleBusinessConfigList(res);
        }).catch(err => {
          console.info(err);
        })
      })
    },
    rowStyle({ row, rowIndex }) {
      if(0 === rowIndex && row.myself){
        return { color: "#333333", background: "#e0e0e0", borderBottom: "1px solid #d9d9d9" };
      }else{
        return { background: "#f1f2f3", borderBottom: "1px solid #d9d9d9" };
      }
    },
    handleClick (tab, event) {
      if (this[event]) {
        this[event].call(this, tab);
      }
    },
    getRowKeys (row) {
      return row.id
    },
    toDateString: function (time, format) {
      let date = new Date(time || new Date())
        , ymd = [this.digit(date.getFullYear(), 4), this.digit(date.getMonth() + 1), this.digit(date.getDate())]
        , hms = [this.digit(date.getHours()), this.digit(date.getMinutes()), this.digit(date.getSeconds())];
      format = format || 'yyyy-MM-dd HH:mm:ss';
      return format.replace(/yyyy/g, ymd[0]).replace(/MM/g, ymd[1]).replace(/dd/g, ymd[2]).replace(/HH/g, hms[0]).replace(/mm/g, hms[1]).replace(/ss/g, hms[2]);
    },
    question(d){
      //this.subscribe = {};
      const { id, code, drugName, drugDosage, packageSpecific } = { ...d.product }
      this.dialogVisible = true;
      this.submitButtonLoading = false;
      this.product.id = id;
      this.product.declareId = d.declareId;
      this.product.drugInfo = `${drugName}-${drugDosage}-${packageSpecific}`;
      //this.product.drsOld = d.drs;
      this.product.statusDesc = d.statusDesc;
      this.product.score = ((Number(d.score) / 2 * 100)>>0) / 100;
      this.product.credential = null;
      this.product.code = code;
      this.product.status = d.status;
      this.fileListCredential = [];
      if(d.offer){
        this.product.blackRecord = d.blackRecord;
        this.fileListCredential.push({ name: `点我查看附件`, url: d.offer, response: {data: d.offer}});
      }
    },
    submitQuestion(formName) {
      this.submitButtonLoading = true;
      this.$refs[formName].validate((valid) => {
        if(valid){
          const { credential, declareId, id } = { ...this[formName] };
          this.$api.memberApi.submitQuestion({ id, credential, declareId }).then(response => {
            this.submitButtonLoading = false;
            if(response.status === 200){
              if(response.data.code === 200){
                this.dialogVisible = false;
                this.$message({ message: response.data.data, offset: 200, type: 'success' });
                setTimeout(() => {
                  this.initView();
                }, 500)
              }else{
                this.$message({ message: response.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        } else {
          this.submitButtonLoading = false;
          return false;
        }
      });
    },
    declareGroupList: function(param){
      return new Promise(resolve => {
        this.$api.memberApi.getDeclareGroupList(param).then(res => {
          this.submitButtonLoading = false;
          if(res.status === 200){
            if(res.data.code === 200){
              resolve(res)
            }else{
              this.$message({ message: res.data.data, offset: 200, type: 'error' });
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      })
    },
    handleDeclareGroupList: function(res){
      this.tableData = [];
      const groupMap = new Map();
      for(let outer of JSON.parse(res.data.data)){
        outer.forEach(w => {
          // console.log(w['categoryId'], ` -> `, w['declareId'])
          if(groupMap.has(w.categoryId)){
            groupMap.get(w.categoryId)['declareList'].push(w)
          }else{
            const { drugCategoryName, drugTypeFlagZx, categoryName, dosageCategoryName } = { ...w.product }
            groupMap.set(w.categoryId, { largeTypeName: drugTypeFlagZx, categoryName, dosageCategoryName, declareList: [w] })
          }
        });
      }

      for (let w of groupMap.entries()) {
        this.tableData.push({ ...w[1], declareNum: w[1]['declareList'].length });
      }
    },
    showQtyScore(d){
      const { id } = { ...d.product }
      this.submitButtonLoading = true;
      this.$api.memberApi.getByAssess({ productId: id, operator: 0, status: 0, declareId: d.declareId }).then(response => {
        this.submitButtonLoading = false;
        if(response.status === 200){
          if(response.data.code === 200){
            if(response.data.data){
              this.goAssess(JSON.parse(response.data.data));
            }
          }else{
            this.$message({ message: response.data.data, offset: 200, type: 'info' });
          }
        }else{
          this.$message.error(`服务忙，请稍后再试`);
        }
      }).catch(error => {
        this.submitButtonLoading = false;
      });
    },
    goAssess(d){
      this.submitButtonLoading = false;
      this.product.drugInfo = `联盟药品质量综合评价：` + [d.drugName, d.drugDosage, d.packageSpecific, d.code].join('-');
      this.product.productId = d.id;
      this.product.code = d.code;
      this.blackInputVisible = false;
      this.product.blackMark = false;

      this.product.remark = d.remark;
      this.product.stype = d.drugCode;
      this.product.score = d.score;
      this.dialogFormVisible = true;
      this.selectedMap.clear();
      const isNew = 0 === d['configIds'].length;
      this.configList.forEach((o, index) => {
        let subKey = (`${o.stype}${o.skey}${o.scode}`).toLowerCase();
        let val = this.product[subKey];
        let exists = -1 < d['configIds'].indexOf(o['id'])
        if('object' === typeof val){
          if(isNew){
            this.product[subKey] = [];
          }else{
            if(exists){
              let score = this.selectedMap.get(subKey) || 0;
              score += Number(o['svalue'])
              this.product[subKey].push(o['id']);
              this.selectedMap.set(subKey, score)
            }else{
              let idx = val.indexOf(o['id']);
              if(-1 < idx){
                this.product[subKey].splice(idx, 1);
              }
            }
          }
        }else{
          if(isNew){
            if(o['flag']){
              this.product[subKey] = o['id'];
              this.selectedMap.set(subKey, Number(o['svalue']))
            }
          }else{
            if(exists){
              this.product[subKey] = o['id'];
              this.selectedMap.set(subKey, Number(o['svalue']))
            }else{
              if(!this.selectedMap.has(subKey)){
                this.product[subKey] = '';
              }
            }
          }
        }
      });
    },
    getBusinessConfig: function(param){
      return new Promise(resolve => {
        this.$api.memberApi.getBusinessConfig(param).then(res => {
          this.submitButtonLoading = false;
          if(res.status === 200){
            if(res.data.code === 200){
              resolve(res)
            }else{
              this.$message({ message: res.data.data, offset: 200, type: 'error' });
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      })
    },
    handleBusinessConfigList: function(res){
      this.configList = [...JSON.parse(res.data.data)]
      this.configList.forEach((w, index) => {
        let {stype, skey, scode, flag } = { ...w };
        let key = [stype, skey, scode].join('').toLocaleLowerCase()
        if('XN' === stype){
          if(null == this.xnConfigMap.get(key)){
            this.xnConfigMap.set(key, [])
          }
          this.xnConfigMap.get(key).push(w);
          //必选项 设置
          if(flag){
            this.requiredMap.set(key, flag);
          }
        }else if('ZN' === stype){
        }
      })
    },
    clearValidate (formName) {
      this.$refs[formName].clearValidate();
    },
    changeCaptcha: function () {
      this.captchaUrl = this.getCaptchaUrl();
    },
    getCaptchaUrl: function () {
      this.form.captcha = '';
      return process.env.VUE_APP_API_URL + 'captcha.svl?d=' + new Date().getTime()
    },
    handleRemoveCredential(file, fileList) {
      console.log(file, fileList);
      this.product.credential = '';
      this.fileListCredential = fileList.slice(0,0);
    },
    handlePreview(file) {
      console.log("handlePreview",file);
      let fileUrl = process.env.VUE_APP_BASE_URL + file.response.data;
      if (!fileUrl.endsWith('.pdf')) {
        this.dialogImageUrl = fileUrl;
        this.dialogImageVisible = true;
      } else {
        this.dialogPdfUrl = fileUrl;
        // this.dialogPdfUrl = pdf.createLoadingTask(fileUrl);
        // this.dialogPdfVisible = true;
        window.open(fileUrl);
      }
    },
    handleExceed(files, fileList) {
      this.$message.error(`当前限制上传 1 个文件`);
    },
    beforeFileUpload(file) {
      const supportFileType = ["jpg", "jpeg", "gif", "png", "bmp","pdf"];
      let type1 = (file.name).substring((file.name).lastIndexOf(".")+1);
      let fileExt = type1.trim().toLowerCase();

      const isSupport = supportFileType.indexOf(fileExt)>-1;
      const isLt100M = file.size / 1024 / 1024 < 10;

      if (!isSupport) {
        this.$message.error('只能上传['+supportFileType+']格式的文件!');
      }
      if (!isLt100M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isSupport && isLt100M;
    },
    handleSuccessCredential(response, file, fileList) {
      if (response.code === 200) {
        this.product.credential = response.data;
        this.fileListCredential = fileList;
        this.clearValidate('product');
      } else {
        this.$message.error(response.msg);
        this.fileListCredential = fileList.slice(0,0);
      }
    },
    handleError(response, file, fileList) {
      this.$message.error(`上传失败，请稍后再试`);
    },
    beforeRemove(file, fileList) {
      console.log(file);
      if(file.status !== 'ready')
        return this.$confirm(`确定移除 ${ file.name }？`);
    },
    goLogin () {
      this.$message({ message: '登录过期，请重新登录账户！', offset: 200, type: 'error' });
      setTimeout(() => {
        this.submitButtonLoading = false;
        window.location.href = process.env.VUE_APP_API_URL;
      }, 2000)
    }
  }
}
</script>
<style>
.el-dialog__footer {
  text-align: center;
}
.el-divider-horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 12px 0;
}
.upload-left {
  text-align: left;
}

.register-wrapper-div {
  padding-top: 10px;
  width: 750px;
  margin: 0 auto;
  background-color: #f8f8f8;
}
.el-dialog__body {
  padding: 10px 20px;
}
.el-radio {
  margin-right: 0;
}
.el-checkbox {
  margin-right: 5px;
}
.el-radio--mini.is-bordered {
  margin: 2px 0;
}
.el-divider--horizontal {
  margin: 10px 0;
}
.el-collapse-item__content {
  padding-bottom: 10px;
}
.el-alert--info.is-light {
  width: auto;
  height: 65%;
  margin-right: 15px;
}
.el-tag--plain--choose {
  text-align: center;
}
.el-tag--plain {
  /* width: 130px; */
  width: auto!important;
  text-align: center;
  border: 0px solid #fff!important;;
}
.radio-br {
  width: 75%;
}
.radio-auto {
  float: left;
  margin-right: 10px;
}
.assess-score {
  margin-right: 10px;
}
.el-badge__content.is-fixed {
    -webkit-transform: translateY(0%) translateX(50%);
    transform: translateY(20%) translateX(70%);
}
.el-collapse-item__arrow.el-icon-arrow-right {
  color: #ffffff;
}

.el-table__expanded-cell[class*=cell] {
  padding: 5px 0px 5px 40px!important;
}
.lvtables {
  width: vw(1471);
  width: 100%;
  height: vh(690);
  height: vh(900);
  overflow: auto;
  padding: 0 vw(24);
  box-sizing: border-box;
  &::-webkit-scrollbar {
      width: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Member/ConcernedAbout.vue